module.exports = __webpack_public_path__ + "static/media/red.200ce619.svg";